import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "button"]

  connect() {
    this.doPortal();
  }

  disconnect() {}

  doPortal() {
    const modalHTML = this.element.innerHTML;
    const modalPortal = document.getElementById('modal-portal');
    modalPortal.insertAdjacentHTML('beforeend', modalHTML);  // Agrega el modal al final del portal
    this.element.innerHTML = null;
  }
}
